'use strict';

exports.__esModule = true;
var DEFAULT_SAMPLE_RATIO = 10;
var store = {};

var getStore = function getStore() {
  return store;
};
var shouldAlwaysInclude = function shouldAlwaysInclude(sampleRatioState, isDebug) {
  return sampleRatioState === 'none' || isDebug && sampleRatioState !== 'force';
};
var fromCoinFn = function fromCoinFn() {
  var sampleRatio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_SAMPLE_RATIO;
  var coin = arguments[1];
  return coin % sampleRatio === 0;
};
var getFromCoin = function getFromCoin(sampleRatio) {
  return fromCoinFn.bind(null, sampleRatio);
};

function isSiteInSampleRatio(_ref) {
  var sampleRatio = _ref.sampleRatio,
      sampleRatioState = _ref.sampleRatioState,
      viewerSessionId = _ref.viewerSessionId,
      requestId = _ref.requestId,
      isDebug = _ref.isDebug,
      biSampleByRequestId = _ref.biSampleByRequestId;

  var fromCoin = getFromCoin(sampleRatio);
  if (shouldAlwaysInclude(sampleRatioState, isDebug)) {
    return true;
  }

  if (!('coinFromRequestId' in store) && requestId) {
    store.coinFromRequestId = parseInt(requestId, 10);
  }

  var isServerSide = !viewerSessionId;
  if (isServerSide) {
    return fromCoin(store.coinFromRequestId);
  }

  if (!('coin' in store)) {
    store.coin = parseInt(viewerSessionId, 16);
  }

  var res = fromCoin(store.coin);
  if (!res && biSampleByRequestId && 'coinFromRequestId' in store) {
    res = fromCoin(store.coinFromRequestId);
  }

  return res;
}

exports.isSiteInSampleRatio = isSiteInSampleRatio;
exports.getStore = getStore;
//# sourceMappingURL=loggingUtils.js.map